<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="white--text primary"
        >SỬA TUYẾN XE {{ busData.title }}
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <BusInfoForm v-if="busData.id" :busData="busData" ref="form" class="mt-6 mx-6" />
      <v-divider></v-divider>
      <v-card-actions class="px-6">
        <v-btn class="px-6" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="px-6" depressed color="primary" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BusInfoForm from '@/components/basic/form/bus/BusInfoForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BusInfoForm
  },
  props: {
    state: Boolean,
    busData: Object,
    slots: Array
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {},
  methods: {
    ...mapActions('busDetail', ['updateBus']),
    cancel() {
      this.dialog = false
      this.$refs.form.resetDefault()
    },
    async save() {
      if (!this.$refs.form.validate()) return
      const data = this.$refs.form.getData()
      this.$loading.active = true
      await this.updateBus({ id: this.busData.id, ...data })
      this.$loading.active = false
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
